export default __webpack_public_path__ + "static/media/wxCode1.3c40020d.png";